import { useEffect } from 'react';

/**
 * 阻止 iframe 滚动溢出到外层页面
 * 只在滚动到边界时阻止溢出，正常滚动不受影响
 */
const usePreventScrollOverspill = () => {
  useEffect(() => {
    const handleWheel = (e: WheelEvent) => {
      const target = e.target as HTMLElement;
      let scrollable: HTMLElement | null = target;

      // 向上查找可滚动元素
      while (scrollable && scrollable !== document.body) {
        const style = window.getComputedStyle(scrollable);
        const overflowY = style.overflowY || style.overflow;

        if (overflowY === 'auto' || overflowY === 'scroll') {
          const { scrollTop, scrollHeight, clientHeight } = scrollable;
          const isAtTop = scrollTop <= 0;
          const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;

          // 在边界时阻止事件传播
          if ((isAtTop && e.deltaY < 0) || (isAtBottom && e.deltaY > 0)) {
            e.stopPropagation();
            return;
          }
          break;
        }
        scrollable = scrollable.parentElement;
      }

      // 检查 root 或 body 的滚动
      const root = document.getElementById('root') || document.body;
      if (root) {
        const { scrollTop, scrollHeight, clientHeight } = root;
        const isAtTop = scrollTop <= 0;
        const isAtBottom = scrollTop + clientHeight >= scrollHeight - 1;

        // 只在边界时阻止传播，正常滚动不受影响
        if ((isAtTop && e.deltaY < 0) || (isAtBottom && e.deltaY > 0)) {
          e.stopPropagation();
        }
      }
    };

    // 使用 capture 阶段捕获事件，确保能阻止传播
    document.addEventListener('wheel', handleWheel, { passive: false, capture: true });

    return () => {
      document.removeEventListener('wheel', handleWheel, { capture: true });
    };
  }, []);
};

export default usePreventScrollOverspill;

